function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.292 62.7083V56L46.0837 56.7292C50.3128 57.6042 54.2503 54.5417 54.542 50.3125L55.417 40.8333L59.6462 39.0833C61.1045 38.5 61.6878 36.75 60.8128 35.2917L55.417 26.25C54.542 15.1667 48.2712 4.375 32.0837 4.375C15.4587 4.375 7.29199 16.625 7.29199 29.1667C7.29199 34.5625 9.18783 39.2292 12.1045 43.1667C14.7295 46.8125 16.042 51.1875 16.042 55.5625V62.5625H42.292V62.7083Z",
  fill: "#C8831D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2913 62.7083V55.9999L32.083 53.9583V62.7083H42.2913Z",
  fill: "#AF7012"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.8545 33.5417C50.0626 33.5417 51.042 32.5624 51.042 31.3542C51.042 30.1461 50.0626 29.1667 48.8545 29.1667C47.6464 29.1667 46.667 30.1461 46.667 31.3542C46.667 32.5624 47.6464 33.5417 48.8545 33.5417Z",
  fill: "#784719"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2087 4.375C17.9378 4.375 7.29199 15.0208 7.29199 28.2917C7.29199 44.4792 16.042 44.9167 16.042 55.4167L19.8337 54.1042C22.8962 53.0833 25.5212 50.75 26.6878 47.6875L30.7712 37.7708L39.3753 33.5417V24.7917C39.3753 24.7917 49.5837 19.25 49.5837 9.77083C45.2087 6.125 37.4795 4.375 31.2087 4.375Z",
  fill: "#233243"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6253 3.0625C29.7503 3.0625 29.167 3.64583 29.167 4.52083V24.7917C29.167 25.6667 29.7503 26.25 30.6253 26.25C31.5003 26.25 32.0837 25.6667 32.0837 24.7917V4.52083C32.0837 3.64583 31.5003 3.0625 30.6253 3.0625Z",
  fill: "#FE5755"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M53.8126 46.5211C42.2918 46.5211 38.7918 39.3753 38.6459 39.0836C38.3543 38.3544 37.4793 38.0628 36.7501 38.3544C36.0209 38.6461 35.7293 39.5211 36.0209 40.2503C36.1668 40.6878 40.3959 49.4378 53.8126 49.4378C54.6876 49.4378 55.2709 48.8544 55.2709 47.9794C55.2709 47.1044 54.5418 46.5211 53.8126 46.5211Z",
  fill: "#FE5755"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M53.9587 51.0416C55.5695 51.0416 56.8753 49.7358 56.8753 48.1249C56.8753 46.5141 55.5695 45.2083 53.9587 45.2083C52.3478 45.2083 51.042 46.5141 51.042 48.1249C51.042 49.7358 52.3478 51.0416 53.9587 51.0416Z",
  fill: "#091D33"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6253 43.7499C36.2632 43.7499 40.8337 39.1795 40.8337 33.5416C40.8337 27.9037 36.2632 23.3333 30.6253 23.3333C24.9874 23.3333 20.417 27.9037 20.417 33.5416C20.417 39.1795 24.9874 43.7499 30.6253 43.7499Z",
  fill: "#091D33"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6253 39.3749C33.847 39.3749 36.4587 36.7632 36.4587 33.5416C36.4587 30.3199 33.847 27.7083 30.6253 27.7083C27.4037 27.7083 24.792 30.3199 24.792 33.5416C24.792 36.7632 27.4037 39.3749 30.6253 39.3749Z",
  fill: "#FE5755"
});

function SvgCustomerSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customerSupport.059dec74.svg";
export { ForwardRef as ReactComponent };